import axios from 'axios';

const getList = params => axios.get('/unidade-medida/page', {
  params,
});
const get = id => axios.get(`/unidade-medida/${id}`, {});

const save = (unidadeMedida) => {
  if (unidadeMedida.id) {
    return axios.put(`/unidade-medida/${unidadeMedida.id}`, unidadeMedida);
  }
  return axios.post('/unidade-medida', unidadeMedida);
};

const remover = id => axios.delete(`/unidade-medida/${id}`);

export default {
  getList,
  get,
  save,
  remover,
};
